var path = '/templates/projects.settings/initialization/cart_price.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.initialization.cartPrice.kaato_goukei_kingaku' | translate }}</h1><zc-session-sampler project=project title=\"{{ 'projectsSettings.initialization.cartPrice.kaato_goukei_kingaku' | translate }}\" indicator=cart_price_found_rate></zc-session-sampler><p class=config-lead>{{ 'projectsSettings.initialization.cartPrice.okyakusama_ga_genzai' | translate }}<br>{{ 'projectsSettings.initialization.cartPrice.settei_shitapeejitaipu_de' | translate }}</p><zc-cart-price-editor project-id=project.id></zc-cart-price-editor></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.settings/initialization/cart_price.html
// module id = 1483
// module chunks = 0